import immutable, { Map } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';
import { reducer as reduxFormReducer } from 'redux-form/immutable';
import { createImmutableReducer } from 'redux-oidc';

import alert from '../containers/Alert/reducer';
import app from '../containers/App/reducer';
import fetch from './fetch/reducer';
import { productsDetails, step } from '../containers/Form/reducer';
import login from '../components/HeaderLogin/reducer';

const oidcReducer = createImmutableReducer(immutable);
/* eslint-disable */
const defaultBreakpoints = {
	extraSmall: 576,
	small: 768,
	medium: 992,
	large: 1200,
};
/* eslint-enable */

const appReducer = combineReducers({
	alert,
	app,
	browser: createResponsiveStateReducer(defaultBreakpoints),
	fetch,
	form: reduxFormReducer,
	oidc: combineReducers({ oidcReducer, login }),
	productsDetails,
	step
});

const rootReducer = (state, action) => {
	if(action.type === 'redux-oidc/SESSION_TERMINATED') {
		const browserState = state.get('browser');
		state = new Map({ browser: browserState });
	}
	return appReducer(state, action);
};

export default rootReducer;
